export default {"src":"/_next/static/media/new.52f1ab94.svg","height":426,"width":416};